import { format } from "date-fns"
import React from "react"
import { store } from "../../../../stores/Store"
import Ajax from "../../../../Ajax"
import { Button } from "@mui/material"


export default function JobDatesSection ({jobNode}) {

    const [submitting, setSubmitting] = React.useState(false)
    const jobToDate = new Date(jobNode.toDate)
    const jobFromDate = new Date(jobNode.fromDate)
    const active = jobToDate > new Date()

    const toggle = async () => {
        setSubmitting(true)

        const updatedNode = {
            ...jobNode,
            toDate: active ? format(new Date(), "yyyy-MM-dd") : "9999-12-31"
        }

        await store.NodeStore.updateOrEditProcedure(async () => {
            await Ajax.Entity.SaveEdit(updatedNode)
        })

        setSubmitting(false)
    }

    return (
        <div className="detail-section">
            <div className="section-table">
                <div className="section-header">
                    <div className="header-content">
                        <h4>Job status</h4>
                    </div>
                </div>

                <div className="section-row attribute-row">
                    <div className="section-cell">Created on</div>
                    <div className="section-cell">{format(new Date(jobNode.fromDate), "yyyy-MM-dd")}</div>
                </div>
                <div className="section-row attribute-row">
                    <div className="section-cell">Status</div>
                    <div className="section-cell">
                        {active ? (
                            <>Active</>
                        ) : (
                            <>Deactivated on {format(new Date(jobNode.toDate), "yyyy-MM-dd")}</>
                        )}
                    </div>
                </div>
            </div>

            <Button
                // color="secondary"
                style={{marginTop: "10px"}}
                variant="contained" 
                className="btn btn-sm"
                disabled={!!store.AppStore.sessionState || submitting}
                onClick={() => toggle()}>
                {active ? "Deactivate" : "Reactivate"}
            </Button>
        </div>
    )
}